
import React from "react";
import { Helmet } from "react-helmet-async";
import { ambulanceServices } from "../data/ambulanceServices";

export default function ServicesSEO() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "Madeshwara Ambulance Services",
    "url": "https://madeshwaraambulance.com/services",
    "logo": "https://madeshwaraambulance.com/assets/logo.png",
    "description": "Comprehensive ambulance services including emergency, ICU, and patient transport across Bangalore and Karnataka.",
    "telephone": "+91 98459 74238",
    "email": "madeshwaraa@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "No.9/8, Near Swimming Pool, 1st Main Road, 1st Block East, Byrasandra, Jayanagar-560011",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560011",
      "addressCountry": "IN"
    },
    "areaServed": "Bangalore, Karnataka, India",
    "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Ambulance Services",
      "itemListElement": ambulanceServices.map((service, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": service.title,
          "description": service.description,
          "image": `https://madeshwaraambulance.com${service.image}`
        },
        "position": index + 1
      }))
    }
  };

  return (
    <Helmet>
      <title>Our Services | Madeshwara Ambulance Bangalore</title>
      <meta
        name="description"
        content="Explore Madeshwara Ambulance services: 24/7 emergency, ICU ambulance, patient transport, and more across Bangalore and Karnataka."
      />
      <meta
        name="keywords"
        content="ambulance services Bangalore, ICU ambulance, patient transport, emergency medical transport"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Our Services | Madeshwara Ambulance Bangalore" />
      <meta property="og:description" content="Fast, reliable ambulance services including emergency, ICU, and patient transport across Bangalore." />
      <meta property="og:image" content="/assets/services-og.jpg" />
      <meta property="og:url" content="https://madeshwaraambulance.com/services" />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Our Services | Madeshwara Ambulance Bangalore" />
      <meta name="twitter:description" content="Comprehensive ambulance services for emergencies and patient transport in Bangalore." />
      <meta name="twitter:image" content="/assets/services-og.jpg" />

      {/* Canonical */}
      <link rel="canonical" href="https://madeshwaraambulance.com/services" />

      {/* JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
